<template>
    <el-dialog
        class="add"
        :visible.sync="addVisible"
        :close-on-click-modal="false"
        @closed="closeDialog"
        width="500px"
        title="Add"
        :lock-scroll="false"
        :modal-append-to-body="false"
        append-to-body
    >
        <div class="container">
            <el-form ref="addForm" :model="addForm" :rules="rules" @keydown.enter.native.prevent>
                <el-row>
                    <el-col :span="24">
                        <el-form-item
                            label="Last Mile"
                            prop="last_mile"
                            size="small"
                        >
                            <el-input
                                clearable
                                size="small"
                                v-model="addForm.last_mile"
                                placeholder="Last Mile"
                            ></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="24">
                        <el-form-item label="Channel Code" prop="channel_code" size="small">
                            <el-select
                                clearable
                                filterable
                                v-model="addForm.channel_code"
                                placeholder="Please select"
                            >
                                <el-option
                                    v-for="item in expressList"
                                    :key="item.id"
                                    :label="item.name"
                                    :value="item.channel_code"
                                >
                                </el-option>
                            </el-select>

                        </el-form-item>
                    </el-col>
                    
                    
                </el-row>
            </el-form>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button
                size="small"
                type="primary"
                @click="save"
                :loading="loading"
                >Save</el-button
            >
            <el-button size="small" @click="addVisible = false"
                >Close</el-button
            >
        </span>
    </el-dialog>
</template>

<script>
import { cmofferApi } from "@/http/cmofferApi.js";
import { mapActions } from "vuex";
export default {
    data() {
        return {
            addForm: {
                last_mile: "",
                channel_code: "",
            },
            expressList:{},
            rules: {
                last_mile: [
                    {
                        required: true,
                        message: "Please input last mile",
                    },
                ],
                channel_code: [
                    {
                        required: true,
                        message: "Please input channel code",
                    },
                ],
            },
        };
    },
    methods: {
        save() {
            this.$refs["addForm"].validate((valid) => {
                if (valid) {
                    this.loading = true;
                    cmofferApi
                        .lastMile(
                            {
                                ...this.addForm,
                            },
                            "post"
                        )
                        .then((res) => {
                            this.loading = false;
                            this.closeDialog();
                            this.$message.success(
                                this.$i18n.locale == "zh" ? "成功" : "Success"
                            );
                            this.$parent[this.funcName] &&
                                    this.$parent[this.funcName]();
                                this.closeDialog();
                        });
                }
            });
            
        },
        closeDialog() {
            this.editForm = {
                last_mile: "",
                channel_code:"",
            };
            this.$refs["addForm"].clearValidate();
            this.$refs["addForm"].resetFields();
            this.$emit("update:addVisible", false);
        },

    },
    props: {
        addVisible: Boolean,
        funcName: String
    },
    watch: {
        addVisible() {
            if (this.addVisible) {
                cmofferApi
                    .expressSelect({}, "get")
                    .then((res) => {
                        if (res) {
                            this.expressList = res.data;
                        }
                    });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.add {
    ::v-deep .container {
        .el-input {
            & + .el-input {
                margin-top: 10px;
            }
        }
        .el-select {
            width: 100%;
        }
        .el-form-item--small {
            margin-bottom: 5px !important;
        }
        .el-checkbox__label {
            font-size: 12px;
        }
        .el-radio-group {
            width: 100%;
        }
    }
}
</style>
